import React    from 'react';
import ReactDOM from 'react-dom';

import "@fontsource/barlow/400.css";
import "@fontsource/barlow/600.css";
import 'typeface-vt323';
import './rsuite.css';
import './index.css';


import App from './App';

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById( 'root' )
);
